module.exports = __webpack_public_path__ + "static/media/car_filled.7932b46e.svg";